// extracted by mini-css-extract-plugin
var _1 = "ProfileSubmenuStyle-module__dropdown-parent___G7Ydy";
var _2 = "ProfileSubmenuStyle-module__dropdown-parent___G7Ydy";
var _3 = "ProfileSubmenuStyle-module__icon___DZmYj";
var _4 = "ProfileSubmenuStyle-module__link___amw1C";
var _5 = "ProfileSubmenuStyle-module__link-active___ZyquY";
var _6 = "ProfileSubmenuStyle-module__link-active___ZyquY";
var _7 = "ProfileSubmenuStyle-module__links-toogle___jhyWy";
var _8 = "ProfileSubmenuStyle-module__links-toogle-open___XnGsV";
var _9 = "ProfileSubmenuStyle-module__links-toogle___jhyWy";
var _a = "ProfileSubmenuStyle-module__links-toogle-open___XnGsV";
var _b = "ProfileSubmenuStyle-module__menu-item___qN5IK";
var _c = "ProfileSubmenuStyle-module__menu-item___qN5IK";
var _d = "ProfileSubmenuStyle-module__new-profile-menu___t2tpa";
var _e = "ProfileSubmenuStyle-module__new-profile-submenu___J_ngv";
var _f = "ProfileSubmenuStyle-module__new-profile-menu___t2tpa";
var _10 = "ProfileSubmenuStyle-module__new-profile-submenu___J_ngv";
var _11 = "ProfileSubmenuStyle-module__profile-avatar___mYaGV";
var _12 = "ProfileSubmenuStyle-module__profile-details___N9F6g";
var _13 = "ProfileSubmenuStyle-module__profile-menu___HIsaQ";
var _14 = "ProfileSubmenuStyle-module__profile-menu-open___ueTLW";
var _15 = "ProfileSubmenuStyle-module__profile-name___QIN6E";
var _16 = "ProfileSubmenuStyle-module__profile-submenu___IA1gb";
var _17 = "ProfileSubmenuStyle-module__profile-avatar___mYaGV";
var _18 = "ProfileSubmenuStyle-module__profile-details___N9F6g";
var _19 = "ProfileSubmenuStyle-module__profile-menu___HIsaQ";
var _1a = "ProfileSubmenuStyle-module__profile-menu-open___ueTLW";
var _1b = "ProfileSubmenuStyle-module__profile-name___QIN6E";
var _1c = "ProfileSubmenuStyle-module__profile-submenu___IA1gb";
export { _1 as "dropdown-parent", _2 as "dropdownParent", _3 as "icon", _4 as "link", _5 as "link-active", _6 as "linkActive", _7 as "links-toogle", _8 as "links-toogle-open", _9 as "linksToogle", _a as "linksToogleOpen", _b as "menu-item", _c as "menuItem", _d as "new-profile-menu", _e as "new-profile-submenu", _f as "newProfileMenu", _10 as "newProfileSubmenu", _11 as "profile-avatar", _12 as "profile-details", _13 as "profile-menu", _14 as "profile-menu-open", _15 as "profile-name", _16 as "profile-submenu", _17 as "profileAvatar", _18 as "profileDetails", _19 as "profileMenu", _1a as "profileMenuOpen", _1b as "profileName", _1c as "profileSubmenu" }
